import { render, staticRenderFns } from "./DecommissionAsset.vue?vue&type=template&id=148f32dd&"
import script from "./DecommissionAsset.vue?vue&type=script&lang=js&"
export * from "./DecommissionAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports